// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"681effdf","69":"8991d3b1"}[chunkId] + ".chunk.css";
};